// components/GoogleAnalytics.js - FIXED VERSION
import { useEffect } from 'react';

const GA_TRACKING_ID = 'G-WWGJ70XRGV';

// Track page views
export const trackPageView = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: path,
    });
  }
};

// Track events
export const trackEvent = (action, category, label, value) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Google Analytics Hook - Simplified
export const useGoogleAnalytics = () => {
  useEffect(() => {
    // Track initial page view
    trackPageView(window.location.pathname);
  }, []);
};

// Google Analytics Component - Simplified
const GoogleAnalytics = () => {
  useGoogleAnalytics();
  return null;
};

export default GoogleAnalytics;